import Button from 'components/ui/Button';
import { IoPlay } from 'react-icons/io5';

const RunButton = () => {
  return (
    <Button style={{ display: 'flex', alignItems: 'center', gap: '6px' }} onClick={() => alert('준비중입니다.')}>
      <IoPlay />
      <span>모델 실행</span>
    </Button>
  );
};

export default RunButton;
